import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const ChevronDown: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
  ...rest
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.7777 16.0378C12.3775 16.533 11.6225 16.533 11.2223 16.0378L7.25422 11.1286C6.72564 10.4747 7.19108 9.5 8.03193 9.5L15.9681 9.5C16.8089 9.5 17.2744 10.4747 16.7458 11.1286L12.7777 16.0378Z"
        fill={color}
      />
    </svg>
  );
};

export default ChevronDown;
